import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1.5rem;
  &:last-of-type {
    border-left: 1px solid #3d3d3d;
  }
`;
export const Row = styled.section`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 4rem;
`;

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1.5rem;
  border-left: 1px solid #3d3d3d;
`;

export const SectionHeader = styled.header`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 1rem;

  h2 {
    font-size: 1.1rem;
    font-weight: bold;
  }
`;

export const AddressesWrapper = styled.div`
  display: grid;
  row-gap: 1.5rem;
  grid-template-rows: 1fr auto-fill;
`;

export const AddressRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width:100%;
  svg {
    margin-right: 2rem;

    path {
      stroke: var(--white);
    }

    cursor: pointer;
  }
`;

export const Topic = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  width:100%;

`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
`;

export const Subtitle = styled.p`
  font-size: 0.875rem;
  color: #b8b8b8;
`;

export const ClientInfoWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  row-gap: 2rem;
  column-gap:4rem;
  grid-template-rows: 1fr 1fr  1fr;
`;

export const BeneficiaryInfoWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  row-gap: 2rem;
  grid-template-rows: 1fr 1fr;
`;
